import React , { Component } from 'react';
import { Row, Col, Card, Button, Select, DatePicker } from 'antd';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import ContactTable from'./ContactTable';
import './page-contact.less';
import AdminService from '../../service/admin/AdminService';
import ErrorBoundary from 'antd/lib/alert/ErrorBoundary';
import SearchSelectComponent, { SearchSelectOption } from '../../components/public/SearchSelectComponent';
import CompanyService, { CompanyListRequest, ICompanyInfoList } from '../../service/company/CompanyService';

interface ContactPageProps {
}

interface ContactPageState {
    salesSelectValue: number | null,
    companySelectValue: number | null,
    customerInputValue: number | null,
    waySelectValue: number | null,
    beginTimeValue: string | null,
    endTimeValue: string | null,
    showAlert :boolean,
    alertMessage: string,
    isAssignModalVisible: boolean,
    assignSalesValue: number | null,
    isImportModalVisible: boolean,
    salesList: Array<{id: number, realName: string}>,
    companyMappedInfo: SearchSelectOption[],
}


//define ContactPage class
class ContactPage extends Component<ContactPageProps, ContactPageState> {
    state = {
        salesSelectValue: null,
        companySelectValue: null,
        customerInputValue: null,
        waySelectValue: null,
        beginTimeValue: null,
        endTimeValue: null,
        showAlert: false,
        alertMessage: '',
        salesList: [],
        isAssignModalVisible: false,
        assignSalesValue: null,
        isImportModalVisible: false,
        companyMappedInfo: [],
    };

    async componentDidMount() {
        window.addEventListener('popstate', this.handlePopState);
        this.getSalesListInfo();
        this.getContactDataBasedOnEntry();

        //获取所有公司信息，用于展示公司下拉选择框内容
        const request: CompanyListRequest = {
            companyQueryParam: {
            },
            pageNo: 1,
            pageSize: 9999999,
        };
        const response = await CompanyService.getCompanyListInfo(request);
            if (response) {
            const pageData: ICompanyInfoList = response.data && response.data.companyInfoList ? response.data.companyInfoList : [];
            const CompanyRecords = pageData && pageData.records ? response.data.companyInfoList.records : [];
            const companyMappedInfo = CompanyRecords.map((item: any) => ({
                key: item.id,
                value: item.name,
            }));
            this.setState({ companyMappedInfo: companyMappedInfo});
        }
    }

    componentWillUnmount() {
        window.removeEventListener('popstate', this.handlePopState);
    }

    //监听浏览器返回事件
    handlePopState = () => {
        sessionStorage.setItem('isBackNavigation', 'true');
    };

    //确定进入方式，并获取数据
    getContactDataBasedOnEntry = () => {
        const isBack = sessionStorage.getItem('isBackNavigation') === 'true';
        const pageNo = isBack ? parseInt(localStorage.getItem('contactCurrentPage') || '1', 10) : 1;
    
        // 更新 localStorage
        localStorage.setItem('contactCurrentPage', pageNo.toString());
        sessionStorage.removeItem('isBackNavigation');
    
        if (!isBack) {
            // 通知 ContactTable 重置分页
            if (this.contactTableRef) {
                this.contactTableRef.setPaginationPage(1);
            }
        }
        // 让 ContactTable 组件加载数据
        this.contactTableRef.getContactTableData(
            pageNo
        );
    };

    contactTableRef: ContactTable;

    // 获取销售列表
    getSalesListInfo = async () => {
        try {
            const response = await AdminService.getSalesListInfo();
            if (response && response.data && response.data.salesInfo) {
                this.setState({ salesList: response.data.salesInfo });
            } else {
                this.setState({ salesList: [] });
                console.warn('获取销售列表数据为空');
            }
        } catch (error) {
            this.setState({ salesList: [] });
            console.error('获取销售列表失败:', error);
        }
    };

    //公司选择框处理
    CompanySelect = () => {
        const handleCompanySelectChange = (key: number | null, value: string | null) => {
            this.setState({ companySelectValue: key }, () => {
                // 状态更新后重新加载数据
                if (this.contactTableRef) {
                    this.contactTableRef.getContactTableData(
                        1,
                        this.state.companySelectValue,
                        this.state.waySelectValue,
                        this.state.customerInputValue,
                        this.state.beginTimeValue,
                        this.state.endTimeValue,
                        this.state.salesSelectValue
                    );
                    this.contactTableRef.setPaginationPage(1);
                }
            });
        };
     
        const handleClear = () => {
            this.setState({ companySelectValue: null }, () => {
                // 状态更新后重新加载数据
                if (this.contactTableRef) {
                    this.contactTableRef.getContactTableData(
                        1,
                        this.state.companySelectValue,
                        this.state.waySelectValue,
                        this.state.customerInputValue,
                        this.state.beginTimeValue,
                        this.state.endTimeValue,
                        this.state.salesSelectValue
                    );
                    this.contactTableRef.setPaginationPage(1);
                }
            });
        };
    
        return (
            <>
                <label className="label-contact_company">公司名：</label>
                <SearchSelectComponent 
                    placeholder="请选择客户公司名"
                    optionProps={this.state.companyMappedInfo} 
                    initialValues={this.state.companySelectValue}
                    onChange={handleCompanySelectChange}
                    onClear={handleClear}
                    disabled={false} 
                    allowClear
                />
            </>
        );
    };

    //销售选择框处理
    SalesSelect = () => {
        return (
            <>
                <label className="label-contact_sales">销售：</label>
                <Select 
                    className="select-contact_sales"
                    onChange={(value) => {
                        this.setState({ 
                            salesSelectValue: value !== undefined && value !== null ? value : null
                        }, () => {
                            // 状态更新后重新加载数据
                            this.contactTableRef.getContactTableData(
                                1,
                                this.state.companySelectValue,
                                this.state.waySelectValue,
                                this.state.customerInputValue,
                                this.state.beginTimeValue,
                                this.state.endTimeValue,
                                this.state.salesSelectValue
                            );
                        });
                        if (this.contactTableRef) {
                            this.contactTableRef.setPaginationPage(1);
                        }
                    }}
                    value={this.state.salesSelectValue !== null ? this.state.salesSelectValue : undefined}
                    allowClear
                    placeholder="请选择"
                >
                    {this.state.salesList && this.state.salesList.map(item => (
                        <Select.Option key={item.id} value={item.id}>
                            {item.realName}
                        </Select.Option>
                    ))}
                </Select>
            </>
        );
    };

    //时间选择处理
    StartTimePick = () => {
        return (
            <>
                <label className="label-contact_timepick">起始时间：</label>
                <DatePicker 
                    style={{ width: '13%' }}
                    placeholder="请选择起始时间"
                    format="YYYY-MM-DD"
                    onChange={(value) => {
                        // 如果有选择日期，则将时间设置为当天的 00:00:00
                        const formattedValue = value ? value.startOf('day').format('YYYY-MM-DD') : null;
                        this.setState({ beginTimeValue: formattedValue });
                    }}
                />
            </>
        );
    };

    EndTimePick = () => {
        return (
            <>
                <label className="label-contact_timepick">截止时间：</label>
                <DatePicker 
                    style={{ width: '13%' }}
                    placeholder="请选择截止时间"
                    format="YYYY-MM-DD"
                    onChange={(value) => {
                        const formattedValue = value ? value.endOf('day').format('YYYY-MM-DD') : null;
                        this.setState({ endTimeValue: formattedValue });
                    }}
                />
            </>
        );
    };

    //查询按钮点击事件
    handleQueryButtonClick = async () => {
        await this.contactTableRef.getContactTableData(
            1,
            this.state.companySelectValue,
            this.state.waySelectValue,
            this.state.customerInputValue,
            this.state.beginTimeValue,
            this.state.endTimeValue,
            this.state.salesSelectValue
        );
        if (this.contactTableRef) {
            this.contactTableRef.setPaginationPage(1);
        }
    };

    render() {
        return (
            <ErrorBoundary>
                <div className="gutter-contact_table">
                    <BreadcrumbCustom breads={['需求沟通信息', '客户沟通记录列表']} />
                    <Row gutter={5}>
                        <Col className="gutter-contact_row" md={25}>
                            <div className="gutter-contact_box">
                                <Card title={<div className="title-list_page">客户沟通记录列表</div>} bordered={false}>
                                    <div style={{ marginBottom: 16 }}>

                                        <this.SalesSelect />

                                        <this.CompanySelect />
                                        
                                        <this.StartTimePick />

                                        <this.EndTimePick />
                                        
                                        <Button className="button-contact_query" type="primary" onClick={this.handleQueryButtonClick}>   
                                            查询
                                        </Button>

                                    </div>
                                    <div className="contact-table-wrapper">
                                    <ContactTable
                                        ref={(ref) => (this.contactTableRef = ref)}
                                        company={this.state.companySelectValue}
                                        way={this.state.waySelectValue}
                                        customer={this.state.customerInputValue}
                                        beginTime={this.state.beginTimeValue}
                                        endTime={this.state.endTimeValue}
                                        sales={this.state.salesSelectValue}
                                    />
                                    </div>
                                </Card>
                            </div>
                        </Col>
                    </Row>

                </div>
            </ErrorBoundary>
        );
        
    }
}

export default ContactPage;
